import { Location } from '@core/Router/locations';
import { ButtonPage } from './pages';

const labPath = '/uilab';

export const uiLabLocations: Location[] = [
    {
        url: `${labPath}/button`,
        Component: ButtonPage,
    },
];
